import React, { useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import SchoolApprovals from "../../components/approvals/SchoolApprovals";
import ExpenseApprovals from "../../components/approvals/ExpenseApprovals";

const Approvals = () => {
	const [currentTab, setCurrentTab] = useState(0);

	const handleTabChange = (event, newValue) => {
		setCurrentTab(newValue);
	};

	return (
		<Box>
			<Typography variant="h6" sx={{ mb: 3 }}>
				Approvals
			</Typography>

			<Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
				<Tabs value={currentTab} onChange={handleTabChange}>
					<Tab label="School Approvals" />
					<Tab label="Expense Approvals" />
					{/* Add more tabs here for other approval types in the future */}
					{/* <Tab label="User Approvals" /> */}
					{/* <Tab label="Visit Approvals" /> */}
				</Tabs>
			</Box>

			{/* Tab Content */}
			<Box>
				{currentTab === 0 && <SchoolApprovals />}
				{currentTab === 1 && <ExpenseApprovals />}
				{/* Add more tab content here for other approval types */}
				{/* {currentTab === 2 && <UserApprovals />} */}
				{/* {currentTab === 3 && <VisitApprovals />} */}
			</Box>
		</Box>
	);
};

export default Approvals;
